import { render, staticRenderFns } from "./OrderNormal.vue?vue&type=template&id=4950064a&"
import script from "./OrderNormal.vue?vue&type=script&lang=js&"
export * from "./OrderNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports